import { render, staticRenderFns } from "./TasksBoardView.vue?vue&type=template&id=585c37ce&scoped=true"
import script from "./TasksBoardView.vue?vue&type=script&lang=js"
export * from "./TasksBoardView.vue?vue&type=script&lang=js"
import style0 from "./TasksBoardView.vue?vue&type=style&index=0&id=585c37ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c37ce",
  null
  
)

export default component.exports